var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#272B30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9726 16.6819L16.0979 19.3546C15.7105 19.9069 16.1055 20.6665 16.7801 20.6665H31.2196C31.8941 20.6665 32.2892 19.9069 31.9018 19.3546L30.0271 16.6819C29.5558 16.0433 28.8093 15.6665 28.0156 15.6665H19.9841C19.1904 15.6665 18.4439 16.0433 17.9726 16.6819Z",
    fill: "#F4D259"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8002 23.6669C32.2127 23.1176 31.8208 22.3332 31.1339 22.3332H16.8658C16.1789 22.3332 15.787 23.1176 16.1995 23.6669L22.0158 31.412C23.0165 32.7172 24.9832 32.7172 25.9839 31.412L31.8002 23.6669Z",
    fill: "#F4D259"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsIcon);
export default __webpack_public_path__ + "static/media/credits-icon.b6f53400a28700fdc3352686f8dc9d06.svg";
export { ForwardRef as ReactComponent };